// extracted by mini-css-extract-plugin
export default {"clipLoader":"ActiveOrders_clipLoader__TLbNH","mainContentContainer":"ActiveOrders_mainContentContainer__skxTY"};